'use client';

import React, { useState, type ReactElement, type ReactNode } from 'react';
import { type TBrows } from '@/common/types/analytics.type';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import CustomerSupportDrawer from '@/common/components/customer-support-drawer';
import Drawer from '@/common/components/drawer/drawer.component';
import SettingMenuList, {
  type SettingItem,
} from '@/common/components/setting/setting-menu-list.component';
import {
  selectDomain,
  selectIsTenant,
  useDomainStore,
} from '@/store/use-domain.store';

export interface SettingProps {
  children: ReactNode;
  id: keyof TBrows;
  className?: string;
}

export type { SettingItem };

export default function Setting({
  children,
  id,
  className,
}: SettingProps): ReactElement {
  const [open, setOpen] = useState(false);
  const [openSupport, setOpenSupport] = useState(false);
  const isTenant = useDomainStore(selectIsTenant);
  const config = useDomainStore(selectDomain);

  const handleSupportToggle = () => {
    setOpenSupport((prev) => !prev);
  };

  return (
    <>
      <AnalyticsWrapper analytics={[id]}>
        <div
          className={className}
          onClick={() => {
            setOpen(true);
          }}
          id={id}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              setOpen(true);
            }
          }}
        >
          {children}
        </div>
      </AnalyticsWrapper>
      <Drawer
        placement="bottom"
        className="rounded-t-3xl"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        height="auto"
      >
        <SettingMenuList
          hideSupportDrawer
          onNavigate={() => {
            setOpen(false);
          }}
          onOpenSupport={() => {
            setOpen(false);
            setOpenSupport(true);
          }}
        />
      </Drawer>
      <CustomerSupportDrawer
        title="تماس با پشتیبانی"
        description={`برای ارتباط با تیم پشتیبانی ${isTenant ? config?.title : 'ویترو'} می‌تونین از روش‌های زیر اقدام کنین:`}
        openSupport={openSupport}
        handleToggle={handleSupportToggle}
      />
    </>
  );
}
